var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.yellowCardWarning.isShow == 1)?_c('div',{staticClass:"yellow-card-warning"},[_vm._v("违规黄牌警示 "),_c('el-button',{staticStyle:{"margin-left":"20px"},attrs:{"type":"text"},on:{"click":_vm.showTip}},[_vm._v("查看详情")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }